const NAVIGATION_CANCEL_SUPPRESSION_WINDOW_MS = 2000;

let lastNavigationCancelAt = 0;

export const markNavigationCancellation = () => {
  lastNavigationCancelAt = Date.now();
};

export const isWithinNavigationCancelSuppressionWindow = () => {
  return Date.now() - lastNavigationCancelAt <= NAVIGATION_CANCEL_SUPPRESSION_WINDOW_MS;
};
